import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import { userDetail } from 'Stores/userDetail';

const MyLeadList = observer(props => {
  const tryLeadBuilder = e => {
    props.history.push('/advanced-search/contact');
  };

  const data = userDetail.myLeadList;
  return (
    <div className="card">
      <div className="card-header">
        <h6 className="card-title">My Leads</h6>
        {data.length ? <Link to="/my-leads">View all</Link> : ''}
      </div>
      <div className="card-body">
        {data.length ? (
          <ul>
            {data.map((item, index) => {
              // console.log('item leads ', item);
              return (
                <li key={item.name}>
                  <Link to={`/my-leads/${item.id}`}>
                    <span>{item.name}</span>
                    <span className="total-lead">{item.count || 0}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className="no-data-exist-card">
            You have not purchased any leads yet.
            <div className="nolist-action-wrap">
              <div
                className="contact-action-btn"
                onClick={e => tryLeadBuilder(e)}
              >
                Try Lead Builder
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default withRouter(MyLeadList);
